import { Text } from '@chakra-ui/react';
import DOMPurify from 'dompurify';

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

const YoplanningHtml = ({ description, ...props }) => {
  return (
    <Text
      fontSize="xs"
      className="yoplanningDescription"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(description ? description.replaceAll('<p></p>', '<br/>') : ''), // we have an html description so this is advised..
      }}
      {...props}
    />
  );
};

export default YoplanningHtml;
